"use client";
import React, { useState, useEffect } from "react";
import Icon from "@/components/ui/AppIcon";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookie-consent");
    if (!accepted) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[200] p-4 sm:p-6">
      <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-2xl border border-border p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1">
          <p className="text-sm font-semibold text-foreground mb-1">🍪 Çerez Politikası</p>
          <p className="text-xs text-muted-foreground leading-relaxed">
            Daha iyi bir deneyim sunmak için çerezler kullanıyoruz. Devam ederek{" "}
            <a href="#" className="text-primary underline">çerez politikamızı</a> kabul etmiş olursunuz.
          </p>
        </div>
        <div className="flex gap-2 shrink-0">
          <button
            onClick={() => setVisible(false)}
            className="px-4 py-2 rounded-full text-xs font-semibold border border-border text-muted-foreground hover:bg-muted transition-colors"
          >
            Reddet
          </button>
          <button
            onClick={accept}
            className="btn-primary text-xs py-2 px-4"
          >
            <Icon name="CheckIcon" size={14} />
            Kabul Et
          </button>
        </div>
      </div>
    </div>
  );
}